module.exports = __webpack_public_path__ + "img/decorate_img.1cfa53e4.png";